/**
 *
 * Authorization
 *
 */
import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { RouteConstants } from '../../routes';
import Login from './pages/Login/Login';
import { Registration } from './pages/Registration/Registration';
import Authenticate from './pages/Authenticate/Authenticate';
import AuthLayout from './parts/AuthLayout/AuthLayout';
import ResetPassword from './pages/ResetPassword/ResetPassword';

interface Props {}

export function Authorization(props: Props) {
  return (
    <AuthLayout>
      <Switch>
        <Redirect
          exact
          from={RouteConstants.auth.index}
          to={RouteConstants.auth.login}
        />
        <Route path={RouteConstants.auth.login} component={Login} />
        <Route
          path={RouteConstants.auth.registration}
          component={Registration}
        />
        <Route
          path={RouteConstants.auth.resetPassword}
          component={ResetPassword}
        />
        <Route
          path={RouteConstants.auth.authenticate}
          component={Authenticate}
        />
      </Switch>
    </AuthLayout>
  );
}
